<div class="modal-header mx-3">
  <h1 class="modal-title fs-5" id="exampleModalLabel">Selecionar a filtragem</h1>
  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.hide()"></button>
</div>
<div class="modal-body mx-3">
  <div class="row gap-3">
    <div class="form-group">
      <label>Ordenar lista por</label>
      <select class="form-select" [(ngModel)]="orderBy">
        <option *ngFor="let item of orderByList" [value]="item.value">
          {{item.label}}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label>De forma</label>
      <select class="form-select" [(ngModel)]="orderByDirection">
        <option *ngFor="let item of orderByDirectionList" [value]="item.value">
          {{item.label}}
        </option>
      </select>
    </div>
    <div class="col-12 text-center mt-3">
      <button type="button" class="btn btn-outline-dark" data-dismiss="modal"
        (click)="modalRef.hide()">CANCELAR</button>
      <button type="submit" class="btn btn-primary" (click)="changeOrderBy()">CONTINUAR</button>
    </div>
  </div>
</div>